import {createActions} from 'redux-arc';
import {GET} from './types';

const materiaApiBase = 'materia/';

export const {types, creators: materiaCreators} = createActions('materia', {
  read: {url: `${materiaApiBase}:id/`, method: GET},
  list: {url: materiaApiBase, method: GET}
});
